<template>
  <div align="center">
    <div class="mgin_bg"></div>
    <div class="container">
      <div class="row" style="padding-top: 10px">
        <div class="col-md-6 pull-left" style="text-align: left">
          <img src="../../assets/img/logo.png" width="200px" height="100px" />
        </div>
        <!-- 语言选择 -->
        <div class="col-md-6 pull-right login-language-container" style="text-align: right; line-height: 40px" v-html="$t('language')"></div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-sm-4 col-lg-4" align="left">
          <div id="login" align="center">
            <div class="col-sm-12" style="margin-bottom: 40px; text-align: center">
              <div class="trapezoid"></div>
              <span class="login_title">GLS TRACKING</span>
            </div>
            <div class="col-sm-12">
              <form>
                <div class="form-group col-sm-12">
                  <span class="input-group-ico glyphicon glyphicon-user"></span>
                  <input id="user_code" name="user_code" class="form-control" type="text" :placeholder="$t('userid')" v-model="loginUser.userCode" />
                </div>
                <div class="form-group col-sm-12">
                  <span class="input-group-ico glyphicon glyphicon-lock"></span>
                  <input id="user_pass" name="user_pass" class="form-control" type="password" :placeholder="$t('password')" v-model="loginUser.passWord" />
                </div>
                <div class="form-group col-sm-12" style="margin-top: 10px">
                  <button type="button" class=" btn btn-primary col-sm-12" :value="$t('login')" @click="login()">

                    <span> <img src="../../assets/img/login.svg" style="width:20px;text-align:right;"></span>
                    <span style="line-height:20px;"> {{$t('login')}}</span>

                  </button>
                  <!-- <div class="btn_green">
                     <font class="icon_pre ficomoon icon-search"></font>
                     <font>$t('login')</font>
                  </div> -->
                </div>
              </form>
            </div>

            <div id="error" class="col-sm-12" style="min-height: 30px">
              <ul>
                <li v-for="error in errors">
                  <font color="red">{{ $t(error.message) }} </font>
                </li>
              </ul>
            </div>

            <div class="col-sm-12">
              <font color="#999999">[{{ $t("totalcount") }}</font>:&nbsp; <font class="count">{{ uerCounter }} </font>
              <font color="#999999"> ]</font>
            </div>
          </div>
        </div>

        <div id="scrach" class="col-sm-8 col-lg-8" style="margin-top: 5%">
          <div style="
              font-size: 45px;
              color: white;
              font-weight: 800;
              text-transform: uppercase;
              margin-bottom: 10px;
            ">
            <font color="#18b832">SOONEST</font>
            <font color="#a7c928"> Global Freight </font>Tracking
          </div>
          <airway-bill-query @query="query"></airway-bill-query>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authenticateLogin, getUsersCounter } from "@/api/userAccess";
import { mapMutations } from "vuex";
import { SET_LOGIN_USER } from "@/store/mutation-types";

import AirwayBillQuery from "@/components/module/airway-bill-query";

export default {
  components: { AirwayBillQuery },
  name: "Index",
  data () {
    return {
      loginUser: {
        userCode: "",
        passWord: "",
      },
      uerCounter: 0,
      errors: [],
      rules: {
        userCode: [
          {
            required: true,
            message: "userAccess_authenticate_user_code_is_required",
          },
        ],
        passWord: [
          {
            required: true,
            message: "userAccess_authenticate_user_pass_is_required",
          },
        ],
      },
    };
  },
  mounted: function () {

    this.initUserCounter();
  },
  created () {

  },
  methods: {
    ...mapMutations([SET_LOGIN_USER]),
    async login () {
      // console.log("进来了登录")
      this.$utils.validate(
        this.loginUser,
        this.rules,
        async (valid, errors) => {
          if (!valid) {
            this.errors = errors;
            return;
          }

          var res = await authenticateLogin(this.loginUser).getResponseAsync();

          if (res === null) {
            return;
          }
          if (res.message && res.code != 200) {
            this.errors = [].concat([{ message: res.message }]);
            return;
          }

          this.SET_LOGIN_USER(res.data);
          this.$router.push({ path: "home" });
        }
      );
    },
    //初始化用户计数
    async initUserCounter () {
      await getUsersCounter().then((res) => {
        if (res.data) {
          this.uerCounter = res.data;
        }
      });
    },
    query (bill) {
      this.$router.push({
        name: "airway-bill-query",
        params: { bill: bill },
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.btn-submit {
  background-image: url("../../assets/img/login.svg");
  background-repeat: no-repeat;
  background-position: left;
  padding-left: 20px;
}

.style1 {
  color: #0000ff;
}

.mgin_bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-width: 1000px;
  z-index: -10;
  zoom: 1;
  background-color: #fff;
  background: url(../../assets/img/home_bg12.png);
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;

  // -webkit-filter: blur(15px);
  //         -moz-filter: blur(15px);
  //         -o-filter: blur(15px);
  //         -ms-filter: blur(15px);
  filter: blur(3px);
}

#login {
  background-color: white;
  border-radius: 4px;
  width: 300px;
  padding: 0px 20px 20px 20px;
  display: inline-block;
  -moz-box-shadow: 2px 2px 10px #999999;
  -webkit-box-shadow: 2px 2px 10px #999999;
  box-shadow: 2px 2px 10px #999999;
  margin-top: 20%;
  text-align: center;
}
#login .input-group-ico {
  position: absolute;
  top: 0;
  left: 34;
  z-index: 2;
  display: block;
  width: 34px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  pointer-events: none;
}
#login .form-control {
  padding-left: 34px;
  height: 40px;
  line-height: 40px;
}
.trapezoid {
  height: 0;
  width: 100%;
  border-top: 40px solid #18b832;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
}

.login_title {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  color: #ffffff;
  font-size: 18px;
  line-height: 40px;
}
ul {
  list-style: none;
  text-align: center;
  margin-left: 0px;
  padding: 0px;
}
</style>


<style>
.login-language-container a,
.login-language-container a:hover {
  color: #ffffff;
}
</style>